const persianDateFormatter = new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
  year: "numeric",
  month: "long",
  day: "numeric",
});

const persianTimeFormatter = new Intl.DateTimeFormat("fa-IR", {
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
});

export function formatPersianDate(value: Date | string | number): string {
  return persianDateFormatter.format(new Date(value));
}

export function formatPersianTime(value: Date | string | number): string {
  return persianTimeFormatter.format(new Date(value));
}
